// Remembers the last caret position (content editor or subject input) so the
// `+` can insert a variable there even after focus moves to the search box.

let target = null;
const listeners = new Set();

function emit() {
  for (const listener of listeners) listener();
}

// TinyMCE: store a non-intrusive (path/offset based) bookmark that survives
// focus loss and does not mutate the document.
export function setEditorTarget(editor) {
  if (!editor?.selection) return;
  target = { type: 'editor', bookmark: editor.selection.getBookmark(2) };
  emit();
}

export function setInputTarget(el) {
  if (!el) return;
  const length = el.value?.length ?? 0;
  target = {
    type: 'input',
    el,
    start: el.selectionStart ?? length,
    end: el.selectionEnd ?? length,
  };
  emit();
}

export function getVariableTarget() {
  return target;
}

// Clears the saved position — used when a new template (new editor) loads so a
// position from the previously edited template can't be reused.
export function resetVariableTarget() {
  target = null;
  emit();
}

// The `+` button is enabled whenever a usable target exists. An input target is
// only usable while its element is still in the DOM (subjects can be removed).
export function hasVariableTarget() {
  if (!target) return false;
  if (target.type === 'input') return document.contains(target.el);
  return Boolean(window.tinymce?.activeEditor);
}

export function subscribeVariableTarget(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
